import React from 'react';

const badgeStyles = {
  free: 'bg-[#F3F4F6] text-[#4B5563] border border-[#E5E7EB]',
  pro: 'bg-[#E0F2FE] text-[#0369A1] border border-[#BAE6FD]',
  premium: 'bg-[#FDF4FF] text-[#86198F] border border-[#F0ABFC]',
  advanced: 'bg-gradient-to-r from-[#FEF3C7] to-[#FDE68A] text-[#92400E] border border-[#FCD34D]',
  partner: 'bg-gradient-to-r from-[#ECFDF5] to-[#D1FAE5] text-[#065F46] border border-[#6EE7B7]',
};

const PlanBadge = ({ plan = 'free' }) => {
  const key = plan.toLowerCase();
  const style = badgeStyles[key] || badgeStyles.free;

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded text-[10px] font-bold uppercase tracking-wide ${style}`}>
      {plan}
    </span>
  );
};

export default PlanBadge;
